import React from 'react';
import Button from 'react-bootstrap/lib/Button';
import Link from 'react-router-dom/Link';
import TextTruncate from 'react-text-truncate';
import Avatar from '../Avatar';
import PlayButton from '../PlayButton';
import {
  stationCreator,
  stationName,
  stationBio,
  avatarContainer,
} from './styles.sass';

export default function StationCreator({
  width = 290,
  height = 376,
  stationId,
  creator: { name, bio, imageUrl, userId },
  onClick,
}) {
  return (
    <div className={stationCreator} style={{ height, width }}>
      <Link
        to={`/s/${stationId}`}
        className={avatarContainer}
        onClick={onClick}
      >
        <Avatar size={212} src={imageUrl} userId={userId} />
        <Button bsStyle="listen">
          <PlayButton size={23} fgColor="#8940FA" bgColor="#FFFFFF" />
          Listen
        </Button>
      </Link>
      <Link to={`/s/${stationId}`} onClick={onClick}>
        <TextTruncate
          containerClassName={stationName}
          line={1}
          truncateText="…"
          text={name}
        />
      </Link>
      {bio && (
        <TextTruncate
          containerClassName={stationBio}
          line={5}
          truncateText="…"
          text={bio}
        />
      )}
    </div>
  );
}
